import '../product-card/product-card-display';
import '../search/search-results';

import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';

import store from '../../store/store';
import { BaseComponent } from '../../features/base-component/base-component';

/**
 * An element to perform plp search using program code
 *
 * @csspart programCode - program code on which search result will be performed.
 *
 */
@customElement('mhecomm-plp-products-tab')
export class PlpProductsTab extends connect(store)(BaseComponent) {
  @property()
  programCode = '';

  renderComp() {
    return html`
      <div class="container" id="plp_products_tab" data-automation-id="plp_products_tab">
        <div class="row">
          <div class="col-12">
            <mhecomm-alert
              id="plp_alert_msg"
              data-automation-id="plp_alert_msg"
              message="Pricing for school accounts will display in the cart once you log in."
              type="info"
              ?dismissible="${true}"
            ></mhecomm-alert>
          </div>

          <div class="col-12 col-md-4 col-lg-4 pe-md-4">
            <mhecomm-search-filters id="plp_search_filters" data-automation-id="plp_search_filters" plpSearch="true">
            </mhecomm-search-filters>
          </div>

          <div class="col-12 col-md-8 col-lg-8 mt-3 mt-md-3 mt-lg-0">
            <div class="row">
              <div class="col-12" id="plp_toolbar" data-automation-id="plp_toolbar">
                <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-column flex-lg-row">
                      <div class="me-lg-3 mb-2 mb-lg-0 flex-grow-1">
                        <label class="form-label fw-bold" for="input-search-box">Search Within</label>
                          <mhecomm-search autoLoad="false" catalog="seg-product" loadResults="true" useSuggestions="false" plpSearch="true" pageSize="20" placeholder="Search by Title, ISBN, MHID, or Keyword"></mhecomm-search>
                      </div>
                      <div class="d-flex">
                        <mhecomm-search-results-sorting
                          id="plp_sort_options"
                          data-automation-id="plp_sort_options"
                          class="flex-grow-1 flex-lg-grow-0 me-3"
                          isPlp="true"
                        ></mhecomm-search-results-sorting>
                        <mhecomm-search-results-view id="plp_view_options" data-automation-id="plp_view_options" color="primary" selectorStyle="fill">
                        </mhecomm-search-results-view>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 my-2" id="messsage_bar">
                <mhecomm-pagination-message
                  message="Showing %first%-%last% of %total% Results"
                  emptyMessage="0 Results"
                  id="pagination_message_top"
                  data-automation-id="pagination_message_top"
                  regionid="results-info-bar"
                >
                </mhecomm-pagination-message>
              </div>

              <div class="col-12" id="plp_search_results_container" data-automation-id="plp_search_results_container">
                <mhecomm-plp-search-results
                  id="plp_search_results"
                  data-automation-id="plp_search_results"
                  autoLoad="true"
                  programCode="${this.programCode}"
                  pageSize="20"
                ></mhecomm-plp-search-results>
              </div>

              <div class="col-12 my-3 my-md-5" id="pagination_bar" data-automation-id="pagination_bar">
                <mhecomm-pagination
                    id="pagination"
                    data-automation-id="pagination"
                    message="Showing %first%-%last% of %total% Results"
                  >
                </mhecomm-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-plp-products-tab': PlpProductsTab;
  }
}
